<template>
  <div>
    <div class="banner-img">
      <router-link :to="'/'"><img src="@/assets/banner.png" /></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "SiteBanner",
};
</script>

<style scoped>
.banner-img {
  width: 1200px;
  margin: 0 auto 0 auto;
  cursor: pointer;
  line-height: 0;
}
</style>
